import Component from "../../lib/component";
import {getThrottledFunction} from "../../helpers/throttle";

export const ReviewTextWrapConfig = {
    baseHtmlClass: 'review__msg__text_wrap',
    selector: '.review__msg__text_wrap',
};

export class ReviewTextWrap extends Component {

    constructor(id_or_element, personElement, review) {
        super({
            element: id_or_element,
            config: ReviewTextWrapConfig
        });

        this.personElement = personElement;
        this.review = review;

        this.avatarWidth = this.getPersonWidth();
        this.avatarHeight = this.getPersonHeight();

        if (this.personElement) {
            const resizeHandler = getThrottledFunction(this.handlePersonResize.bind(this), 100);
            this.observer = new ResizeObserver(resizeHandler);
            this.observer.observe(this.personElement);
        }

        this.render();
    }

    handlePersonResize() {
        this.avatarWidth = this.getPersonWidth();
        this.avatarHeight = this.getPersonHeight();
        this.render();
    }

    render() {
        if (this.avatarWidth) this.element.style['width'] = this.avatarWidth + 'px';
        if (this.avatarHeight) this.element.style['height'] = this.avatarHeight + 'px';
    }

    getPersonWidth() {
        if (!this.personElement) return;
        return this.personElement.offsetWidth;
    }

    getPersonHeight() {
        if (!this.personElement) return;
        return this.personElement.offsetHeight;
    }
}
